import type { AuthResponse } from '@posilka/shared';
import { retrieveRawInitData } from '@telegram-apps/sdk-react';
import { runtime } from '@/lib/runtime';
import { api } from '@posilka/client/api/client';

/**
 * Telegram yuborgan asl initData satri (URL hash'idagi `tgWebAppData`). SDK'ning
 * `retrieveRawInitData()` sahifa qayta yuklangach satrni saqlangan ma'lumotdan qayta yig'adi —
 * tartib/kodlash farq qilib, imzo (HASH_INVALID) buziladi. `main.tsx` hash'ni reload'da tiklaydi.
 */
function rawInitDataFromHash(): string | undefined {
  const value = new URLSearchParams(window.location.hash.slice(1)).get('tgWebAppData');
  return value || undefined;
}

/** Telegram initData → JWT. Dev mock rejimida — seed foydalanuvchisi sifatida `/auth/dev`. */
export function login(): Promise<AuthResponse> {
  if (runtime.mocked) {
    return api<AuthResponse>('/auth/dev', {
      method: 'POST',
      body: { telegramId: String(runtime.mockTelegramId) },
    });
  }
  const initData = rawInitDataFromHash() ?? retrieveRawInitData();
  if (!initData) throw new Error('initData not available');
  return api<AuthResponse>('/auth/telegram', { method: 'POST', body: { initData } });
}
